import { MonetizeEditor } from "../editors/monetizeEditor";
import { SelectEditor } from "../editors/selectEditor";
import { CreateableSelectEditor } from "../editors/createableSelectEditor";
import { dateTimeRenderer } from "../renderers/dateTimeRenderer";
import { monetizeRenderer } from "../renderers/monetizeRenderer";
import { trueFalseRenderer } from "../renderers/trueFalseRenderer";
import { associationRenderer } from "../renderers/associationRenderer";
import { safeHTMLRenderer } from "../renderers/safeHTMLRenderer";
import { coloredRenderer } from "../renderers/coloredRenderer";
import { DeploymentStatusSelectEditor } from "../editors/deploymentStatusSelectEditor";
import { deploymentStatusRenderer } from "../renderers/deploymentStatusRenderer";
import { minutesRenderer } from "../renderers/minutesRenderer";
import { DateTimeEditor } from "../editors/dateTimeEditor";
import { dateRenderer } from "../renderers/dateRenderer";

const trueFalseOptions = [
  { value: false, text: "No" },
  { value: true, text: "Yes" },
];

const formatUSD = {
  pattern: "0,0.00",
  culture: "en-US",
};

export const columns = [
  {
    data: "id",
    title: "ID",
    editor: false,
    readOnly: true,
  },
  {
    data: "merchant",
    title: "Merchant",
    url: "/merchants.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "merchant",
    asyncOptions: true,
  },
  {
    data: "mid_type",
    title: "MID Type",
    url: "/deployments/mid_types.json",
    editor: SelectEditor,
  },
  {
    data: "deployment_status",
    title: "Deployment Status",
    url: "/deployment_statuses.json",
    editor: DeploymentStatusSelectEditor,
    renderer: deploymentStatusRenderer,
  },
  {
    data: "app_in_date",
    title: "Docs Out Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "e_sign_date",
    title: "Close Won Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "docs_sign_turn_time",
    title: "Docs Sign Turn Time",
    renderer: minutesRenderer,
    readOnly: true,
  },
  {
    data: "activation_call_date",
    title: "Activation Call Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "activation_call_turn_time",
    title: "Activation Call Turn Time",
    renderer: minutesRenderer,
    readOnly: true,
  },
  {
    data: "application_status",
    title: "App Status",
    url: "/deployments/application_statuses.json",
    editor: SelectEditor,
    renderer: coloredRenderer,
  },
  {
    data: "boarding_in_progress_date",
    title: "B-In Progress Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "uw_date",
    title: "UW Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "uw_turn_time",
    title: "UW Turn Time",
    renderer: minutesRenderer,
    readOnly: true,
  },
  {
    data: "approved_date",
    title: "Approved Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "approval_turn_time",
    title: "Approval Turn Time",
    renderer: minutesRenderer,
    readOnly: true,
  },
  {
    data: "resubmit_date",
    title: "ReSubmit Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "declined_date",
    title: "Declined Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "in_progress_date",
    title: "D-In Progress Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "deployment_date",
    title: "HW Ready Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "shipped_date",
    title: "Shipped Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "shipped_turn_time",
    title: "Shipped Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "deployment_turn_time",
    title: "Deployment Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "deployment_type",
    title: "Delivery Method",
    url: "/deployments/deployment_types.json",
    editor: SelectEditor,
  },
  {
    data: "delivered_date",
    title: "Delivered Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "delivered_turn_time",
    title: "Delivered Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "installation_call_date",
    title: "Installation Call Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "installation_turn_time",
    title: "Installation Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "delivery_status",
    title: "Delivery Status",
  },
  {
    data: "processing_start_date",
    title: "Live Start Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "live_turn_time",
    title: "Live Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "risk_status",
    title: "High Risk / Low Risk",
    editor: SelectEditor,
    selectOptions: [
      { value: "High Risk", label: "High Risk" },
      { value: "Low Risk", label: "Low Risk" },
      { value: "TBD", label: "TBD" },
    ],
  },
  {
    data: "sales_channel",
    title: "Channel (Agent)",
    url: "/sales_channels.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "sales_channel",
  },
  {
    data: "sales_manager",
    title: "Sales Manager",
  },
  {
    data: "processor",
    title: "Processor",
    url: "/processors.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "processor",
  },
  {
    data: "platform",
    title: "Platform",
    url: "/platforms.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "platform",
  },
  {
    data: "bp_price",
    title: "Pricing",
    type: "numeric",
    numericFormat: formatUSD,
  },
  {
    data: "per_transaction",
    title: "Per Trans ($)",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "projected_volume",
    title: "Projected Volume",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "actual_volume",
    title: "Actual Volume",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "hardware_payment_term",
    title: "Payment Term",
    url: "/deployments/hardware_payment_terms.json",
    editor: SelectEditor,
  },
  {
    data: "payment_form_list",
    title: "Payment Form",
    editor: false,
    readOnly: true,
  },
  {
    data: "invoices",
    title: "Invoices",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "paid_amount",
    title: "Paid Amount",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "payment_turn_time",
    title: "Payment Turn Time",
    readOnly: true,
    renderer: minutesRenderer,
  },
  {
    data: "leasing_status",
    title: "Leasing Status",
    editor: SelectEditor,
    selectOptions: [
      { value: "Approved", label: "Approved" },
      { value: "Declined", label: "Declined" },
    ],
  },
  {
    data: "leasing_grade",
    title: "Leasing Grade",
    editor: SelectEditor,
    selectOptions: [
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "C", label: "C" },
      { value: "D", label: "D" },
      { value: "E", label: "E" },
    ],
  },
  {
    data: "leasing_term",
    title: "Leasing Term",
    editor: SelectEditor,
    selectOptions: [
      { value: "12", label: "12" },
      { value: "24", label: "24" },
      { value: "36", label: "36" },
      { value: "48", label: "48" },
    ],
  },
  {
    data: "funding_factor",
    title: "Funding Factor",
  },
  {
    data: "monthly_payment",
    title: "Monthly Payment",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "cash_bonus_offered",
    title: "Bonus Offered",
    renderer: trueFalseRenderer,
    editor: SelectEditor,
    selectOptions: trueFalseOptions,
  },
  {
    data: "cash_bonus",
    title: "Cash Bonus",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
    readOnly: false,
  },
  {
    data: "hardware_cost",
    title: "Hardware Cost",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "overhead",
    title: "Overhead",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "marketing_deployment_cost",
    title: "Marketing/Deployment Cost",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "agent_price",
    title: "Agent Price",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "agent_split",
    title: "Agent Commission",
    readOnly: true,
    renderer: monetizeRenderer,
  },
  {
    data: "agent_split_status",
    title: "Agent Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateRenderer,
  },
  {
    data: "contribution_margin",
    title: "Contribution Margin",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "company_net",
    title: "Company Net",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "hdw_payment_split_term",
    title: "HDW Payment Split Terms",
    renderer: (_instance, td, _row, _col, _prop, value) => {
      if (value !== null) {
        td.innerText = `${value}%`;
      }

      return td;
    },
  },
  {
    data: "agent_deduction",
    title: "Agent Deduction",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "ae_mid_commission",
    title: "AE MID Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
  },
  {
    data: "sm_commission",
    title: "SM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
  },
  {
    data: "gsm_commission",
    title: "GSM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
  },
  {
    data: "dsm_commission",
    title: "DSM Commission",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "dm_commission",
    title: "DM Commission",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "sm_paid_date",
    title: "SM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateRenderer,
  },
  {
    data: "gsm_paid_date",
    title: "GSM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateRenderer,
  },
  {
    data: "dsm_paid_date",
    title: "DSM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateRenderer,
  },
  {
    data: "dm_paid_date",
    title: "DM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateRenderer,
  },
  {
    data: "pci_required",
    title: "PCI",
    renderer: trueFalseRenderer,
    editor: SelectEditor,
    selectOptions: trueFalseOptions,
  },
  {
    data: "notes",
    title: "Notes",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "hardware",
    title: "Hardware",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "menu_status",
    title: "Menu Status",
    url: "/deployments/menu_statuses.json",
    editor: SelectEditor,
  },
  {
    data: "created_by",
    title: "Created By",
    editor: false,
  },
  {
    data: "iris_connection",
    title: "IRIS Connection",
    renderer: trueFalseRenderer,
    editor: SelectEditor,
    selectOptions: trueFalseOptions,
  },
];
